export function customRule(isSatisfied: boolean, message: string): (value: any) => boolean | string {
  return () => isSatisfied || message;
}
